export interface IPhoneNumber {
  countryCode: string;
  phoneNumber: string;
}
